export const allRoutes = {
    analytics: '/analytics',
    expenseReports:'/expense-reports',
    expenseWizard:'/expense-wizard',
    backupApprovers:'/backup-approvers'
}